import { createStore, createHook } from 'react-sweet-state';
import type { Action } from 'react-sweet-state';

type MentionsNotificationsState = {
	deletedMentions: { type: 'deleted'; localId: string; id: string }[];
};
const initialState: MentionsNotificationsState = {
	deletedMentions: [],
};
const actions = {
	setDeletedMentions:
		(mentionIds: { type: 'deleted'; localId: string; id: string }[]): Action<typeof initialState> =>
		({ setState }) => {
			setState({
				deletedMentions: mentionIds,
			});
		},
};
const MentionsNotificationsStore = createStore({
	initialState,
	actions,
	name: 'MentionsNotificationsStore',
});
export const useMentionsNotifications = createHook(MentionsNotificationsStore);
